<template>
  <div v-if="getPermission.stores.view">

    <store-special-form ref="CreateForm" mode="create"/>
    <store-special-form ref="UpdateForm" mode="update"/>

    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">

          <div class="md-layout-item md-size-50 md-small-size-100">

            <div class="md-layout md-gutter">

              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.validDate">
                  <label>Valid Date</label>
                </datepicker>
              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">
                <master-data-select label="Hauler" group="Hauler" v-model="searchRequest.haulerId"/>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <master-data-select label="EndOutlet" group="EndOutlet" v-model="searchRequest.endOutletId"/>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <master-data-select label="Special Status" group="StoreSpecialStatus" v-model="searchRequest.statusId"/>
              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>StoreId</label>
                  <md-input v-model="searchRequest.fromId" @keyup.enter="doSearch"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>To</label>
                  <md-input v-model="searchRequest.toId" @keyup.enter="doSearch"/>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter" v-if="getStoreSpecials.length > 0">
              <div class="md-layout-item md-small-size-100">
                <calling-api :paths="['/api/w/excel/generate','/api/w/stores/special/action']">
                  <md-button v-if="getPermission.stores.edit" :disabled="!canCopy" class="md-raised" @click="doCopy">Copy</md-button>
                  <md-button v-if="getPermission.stores.edit" :disabled="!canDelete" class="md-raised md-accent" @click="doDelete">Delete</md-button>
                  <md-button v-if="getStoreSpecials.length > 0" class="md-raised" @click="doDownloadExcel">Download</md-button>
                </calling-api>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>State</label>
                  <md-input v-model="searchRequest.fromState" @keyup.enter="doSearch"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>To</label>
                  <md-input v-model="searchRequest.toState" @keyup.enter="doSearch"/>
                </md-field>
              </div>
            </div>
            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>City</label>
                  <md-input v-model="searchRequest.fromCity" @keyup.enter="doSearch"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>To</label>
                  <md-input v-model="searchRequest.toCity" @keyup.enter="doSearch"/>
                </md-field>
              </div>
            </div>

            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <calling-api path="/api/w/stores">
                  <md-card-actions>
                    <md-button @click="doSearch" class="md-primary md-raised">Search</md-button>
                    <md-button @click="clearSearch" class="md-raised">Clear</md-button>
                  </md-card-actions>
                </calling-api>
              </div>
            </div>
          </div>
        </div>

      </md-card-content>


    </md-card>

    <div v-if="getPermission.stores.edit">
      <md-button @click="toggleCreate" class="md-fab-bottom-right md-fab md-primary">
        <md-icon>add</md-icon>
      </md-button>
    </div>

    <pagination :items="items">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2"></th>
                    <th class="header-cell w2-5" v-if="getPermission.stores.edit"></th>
                    <th class="header-cell w4">Store ID</th>
                    <th class="header-cell w3">Store</th>
                    <th class="header-cell w5">Start Date</th>
                    <th class="header-cell w5">End Date</th>
                    <th class="header-cell w5">Store Time From</th>
                    <th class="header-cell w5">Store Time To</th>
                    <th class="header-cell w5">Dispatcher ID</th>
                    <th class="header-cell w8">Dispatcher</th>
                    <th class="header-cell w5">Haulier ID</th>
                    <th class="header-cell w8">Haulier Name</th>
                    <th class="header-cell w5">Special Status ID</th>
                    <th class="header-cell w5">Special Status</th>
                    <th class="header-cell w8">Driver Remark</th>
                    <th class="header-cell w3">Driver Group</th>
                    <th class="header-cell w6">Transloading Point Id</th>
                    <th class="header-cell w8">Transloading Point</th>
                    <th class="header-cell w10">End Outlet(s)</th>
                    <th class="header-cell w8">Default End Outlet</th>
                    <th class="header-cell w5">Route ID</th>
                    <th class="header-cell w10">Route Desc</th>
                    <th class="header-cell w5">Pickup Type</th>
                    <th class="header-cell w5">Pickup Weekday</th>
                    <th class="header-cell w5">Create Person</th>
                    <th class="header-cell w5">Create Date</th>
                    <th class="header-cell w5">Create Time</th>
                    <th class="header-cell w5">Change Person</th>
                    <th class="header-cell w5">Change Date</th>
                    <th class="header-cell w5">Change Time</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr v-for="item in pageItems">
                    <td class="body-cell w2">
                      <md-checkbox v-model="item.selected"></md-checkbox>
                    </td>
                    <td class="body-cell w2-5" v-if="getPermission.stores.edit">
                      <md-button @click="toggleUpdate(item)" class="md-icon-button">
                        <md-icon>mode_edit</md-icon>
                      </md-button>
                    </td>
                    <td class="body-cell w4">
                      <template v-if="item.storeDto">{{item.storeDto.id}}</template>
                      <template v-else>{{item.storeId}}</template>
                    </td>
                    <td class="body-cell w3">
                      <template v-if="item.storeDto">{{item.storeDto.name}}</template>
                    </td>
                    <td class="body-cell w5">{{item.startDate | date}}</td>
                    <td class="body-cell w5">{{item.endDate | date}}</td>
                    <td class="body-cell w5">{{item.storeTimeFrom}}</td>
                    <td class="body-cell w5">{{item.storeTimeTo}}</td>
                    <td class="body-cell w5">{{item.dispatcherId}}</td>
                    <td class="body-cell w8">{{item.dispatcherName}}</td>
                    <td class="body-cell w5">{{item.haulerId}}</td>
                    <td class="body-cell w8">{{item.haulerName}}</td>
                    <td class="body-cell w5">{{item.statusId}}</td>
                    <td class="body-cell w5">{{item.statusName}}</td>
                    <td class="body-cell w8">{{item.driverRemark}}</td>
                    <td class="body-cell w3">{{item.driverGroup}}</td>
                    <td class="body-cell w6">{{item.transloadingPoint}}</td>
                    <td class="body-cell w8">
                      {{getTransloadingPoint(item)}}
                    </td>
                    <td class="body-cell w10">
                      <div v-for="id in item.endOutletIds" style="padding: 4px">
                        <master-data-display group="EndOutlet" :tag-id="id"/>
                      </div>
                    </td>
                    <td class="body-cell w8">
                      <master-data-display group="EndOutlet" :tag-id="item.endOutletId"/>
                    </td>
                    <td class="body-cell w5">{{item.routeId}}</td>
                    <td class="body-cell w10">{{item.routeDesc}}</td>
                    <td class="body-cell w5">
                      <template v-if="item.storeDto">
                        <master-data-display group="PickupType" :tag-id="item.storeDto.pickUpTypeId"/>
                      </template>
                    </td>
                    <td class="body-cell w5">{{getDaysDisplay(item.days)}}</td>
                    <td class="body-cell w5">{{item.createdBy}}</td>
                    <td class="body-cell w5">{{item.createdAt | date}}</td>
                    <td class="body-cell w5">{{item.createdAt | time}}</td>
                    <td class="body-cell w5">{{item.updatedBy}}</td>
                    <td class="body-cell w5">{{item.updatedAt | date}}</td>
                    <td class="body-cell w5">{{item.updatedAt | time}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>

</style>

<script>
  import { mapGetters } from 'vuex';
  import toGenerateExcelRequest from '../utils/excel.js';
  import StoreSpecialForm from '../components/StoreSpecialForm.vue';
  import dateFormat from '../utils/dateFormat'

  const getInitSearch = () => ({
    includingStoreSpecial: true,
    fromId: null,
    toId: null,
    fromState: null,
    toState: null,
    fromCity: null,
    toCity: null,
    validDate: null,
    statusId: null,
    haulerId: null,
    endOutletId: null,
  });

  export default {
    data: () => ({
      searchRequest: getInitSearch(),
      dialog: {
        isShowing: false,
      },
      items: [],
    }),
    components: {
      StoreSpecialForm,
    },
    watch: {
      getStoreSpecials(val) {
        this.updateItems(val);
      },
    },
    computed: {
      ...mapGetters([
        'getStoreSpecials',
        'getMasterDataName',
        'getMasterDataByGroup',
        'getPermission',
      ]),
      getSelectedItems() {
        return _(this.items).filter(it => it.selected);
      },
      canCopy() {
        return this.getSelectedItems.length === 1;
      },
      canDelete() {
        return this.getSelectedItems.length > 0;
      },
    },
    mounted() {
      let cachedSearchRequest = this.$store.state.store.searchRequest;
      if (cachedSearchRequest) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      }

      this.updateItems(this.getStoreSpecials);
    },
    methods: {
      updateItems(itemsSource) {
        _(itemsSource).each(it => it.selected = false);
        this.items = JSON.parse(JSON.stringify(itemsSource));
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header')).offset({ left: -1 * (e.target.scrollLeft - $('.outer-container').offset().left) });
      },
      toggleCreate() {
        this.$refs.CreateForm.openDialog();
      },
      toggleUpdate(item) {
        this.$refs.UpdateForm.openDialog(item);
      },
      doCopy() {
        const promises = _(this.getSelectedItems).map((it) => {
          const startDate = moment(it.endDate).add(1, 's').toDate();
          const endDate = moment(startDate)
            .add(
              Math.abs(moment(it.startDate).diff(moment(it.endDate), 's')),
              's',
            )
            .toDate();
          const req = {
            action: "create",
            storeSpecialDto: {
              day: it.day,
              days: it.days,
              dispatcherId: it.dispatcherId,
              dispatcherName: it.dispatcherName,
              driverGroup: it.driverGroup,
              driverRemark: it.driverRemark,
              endDate,
              haulerId: it.haulerId,
              haulerName: it.haulerName,
              routeDesc: it.routeDesc,
              routeId: it.routeId,
              startDate,
              statusId: it.statusId,
              statusName: it.statusName,
              storeId: it.storeId,
              storeTimeFrom: it.storeTimeFrom,
              storeTimeTo: it.storeTimeTo,
              endOutletId: it.endOutletId,
              transloadingPoint: it.transloadingPoint,
            },
          };
          console.log(JSON.stringify(req));
          return this.$store.dispatch("doActionOnStoreSpecial", req);
        });
        Promise.all(promises).then(() => this.$store.dispatch('loadStoreSpecials'));
      },
      doDelete() {
        const promises = _(this.getSelectedItems).map((it) => {
          const req = {
            action: "delete",
            storeSpecialDto: it,
          };
          console.log(JSON.stringify(req));
          return this.$store.dispatch("doActionOnStoreSpecial", req);
        });
        Promise.all(promises).then(() => this.$store.dispatch('loadStoreSpecials'));
      },
      doSearch() {
        this.$store.dispatch('loadStoreSpecials', this.searchRequest);
      },
      doDownloadExcel() {
        const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'Store Remark and Special Status.xls',
          2,
        );

        request.rows = _(this.items).map(item => [
          item.storeId,
          _(item).lookup('storeDto.name'),
          dateFormat.date(item.startDate),
          dateFormat.date(item.endDate),
          item.storeTimeFrom,
          item.storeTimeTo,
          item.dispatcherId,
          item.dispatcherName,
          item.haulerId,
          item.haulerName,
          item.statusId,
          item.statusName,
          item.driverRemark,
          item.driverGroup,
          item.transloadingPoint,
          this.getTransloadingPoint(item),
          item.endOutletIds.join(','),
          item.endOutletId,
          item.routeId,
          item.routeDesc,
          _(item).lookup('storeDto.pickUpTypeId'),
          this.getDaysDisplay(item.days),
          item.createdBy,
          dateFormat.date(item.createdAt),
          dateFormat.time(item.createdAt),
          item.updatedBy,
          dateFormat.date(item.updatedAt),
          dateFormat.time(item.updatedAt),
        ]);

        this.$store.dispatch('generateExcel', request).then((res) => {
          window.open(res.url, 'blank');
        });
      },
      clearSearch() {
        _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear')).each((it) => {
          it.click();
        });
        this.$nextTick(() => {
          this.searchRequest = getInitSearch();
        });
      },
      getDaysDisplay(days) {
        return _(days).map(it => dateFormat.weekDayDisplay(it)).join(',');
      },
      getTransloadingPoint(item) {
        const pickUpTypeId = _(item).lookup('storeDto.pickUpTypeId');
        if (pickUpTypeId === "ZE") {
          return this.getMasterDataName('EndOutletMilkRun1', item.transloadingPoint)
        } else if (pickUpTypeId === "ZF") {
          return this.getMasterDataName('EndOutletMilkRun2', item.transloadingPoint)
        }
        return '';
      }
    },
  };

</script>
